/**
 * @module app.shared
 */

import { SessionChangeEventKey } from 'app/shared/lib/session/session-types';

const contextKeys: SessionChangeEventKey[] = ['checkIn', 'expire', 'logIn', 'logOut', 'error'];

const lockKeys: SessionChangeEventKey[] = ['lock', 'unlock'];

const logOutKeys: SessionChangeEventKey[] = ['expire', 'logOut', 'error', 'authFailed'];

const appKeys: SessionChangeEventKey[] = ['startup', 'account', 'shutdown'];

export class SessionChangedEvent {

    constructor(public readonly key: SessionChangeEventKey) { }

    public get hasUserContextChanged(): boolean {
        return contextKeys.indexOf(this.key) >= 0;
    }

    public get hasUserLoggedOut(): boolean {
        return logOutKeys.indexOf(this.key) >= 0;
    }

    public get hasLockedChanged(): boolean {
        return lockKeys.indexOf(this.key) >= 0;
    }

    public get hasAppStateChanged(): boolean {
        return appKeys.indexOf(this.key) >= 0;
    }
}

export interface SessionExpiringEventData {
    readonly isAlerted: boolean;
    readonly seconds: number;
    readonly expiringType: 'warning' | 'critical';
}

export class SessionExpiringEvent {
    constructor(public readonly data: SessionExpiringEventData) { }
}
